<template>
    <div class="main" id="taskForm" v-if="form.extraInfo">
        <InsuranceInfo :info="form" v-if="form.productCode=='JIANGONG_DEPOSIT'"></InsuranceInfo>
        <Form :model="form" :label-width="170" class="mt15" ref="form" v-else>
            <FormItem label="建筑工程项目合同地址：" class="w600" prop="companyName">
                {{form.extraInfo.projectAddress}}
            </FormItem>
            <FormItem label="工程造价：" class="w600" prop="idType">
                {{form.extraInfo.projectCost}}
            </FormItem>
            <FormItem label="计费方式：" class="w600" prop="contactsPhone">
                {{form.extraInfo.chargeMode}}
            </FormItem>
            <FormItem label="建筑工程项目合同期限：" class="w600" prop="address">
                {{form.extraInfo.projectDateStart}}- {{form.extraInfo.projectDateEnd}}
            </FormItem>
            <FormItem label="营业执照：" class="w600" prop="zipCode">
                <div v-for="(item,index) in form.extraInfo.uploadListLicenseArr" :key="index">
                    <div  class="upItem" >
                        <a :href="item.url">{{ item.name }}</a>
                    </div>
                </div>
            </FormItem>
            <FormItem label=" 工程合同：" class="w600" prop="contactsName">
                <div v-for="(item,index) in form.extraInfo.uploadList" :key="index">
                    <div  class="upItem" >
                        <a :href="item.url">{{ item.name }}</a>
                    </div>
                </div>
            </FormItem>
            <FormItem label="保单发票邮寄地址：" prop="postAddress" class="w600">
                {{form.extraInfo.postAddress}}
            </FormItem>
            <FormItem label="邮寄联系人：" prop="postContactName" class="w600">
                {{form.extraInfo.postContactName}}
            </FormItem>
            <FormItem label="邮寄联系人电话：" prop="postContactPhone" class="w600">
                {{form.extraInfo.postContactPhone}}
            </FormItem>
        </Form>
        <p class="title">保障计划</p>
        <SecurityPlan v-if="form.productCode=='JIANGONG_DEPOSIT'" :info="form"></SecurityPlan>
        <div v-else>
            <Form :model="form" :label-width="170" class="mt15" ref="form" >
                <FormItem label="保障起期：" class="w600" prop="contactsPhone">
                    {{form.effectiveDateStart}}
                </FormItem>
                <FormItem label="保障止期：" class="w600" prop="contactsEmail">
                    {{form.effectiveDateEnd}}
                </FormItem>
                <FormItem label="选择类型：" class="w600" prop="contactsCertificateNumber">
                    {{form.productName}}
                </FormItem>
                <FormItem label="选择保额：" class="w600" prop="enterpriseNatureCode">
                    {{form.extraInfo.schemeName}}
                </FormItem>
                <FormItem label="合同类型：" class="w600">{{form.extraInfo.contractType=='TOTAL'?'总包':'分包'}}</FormItem>
                <FormItem label="总费用：" class="w600" prop="businessScope">
                    {{form.premium}}元
                </FormItem>
            </Form>
            <p class="title"  >流程相关附件</p>
            <Table border :columns="columns12" :data="form.fileList" >
                <template slot-scope="{ row }" slot="name">
                    {{ row.name }}
                </template>
                <template slot-scope="{ row, index }" slot="action">
                    <a :href="row.fileUrl" @click="handelLoad">下载</a>
                </template>
            </Table>
            <p class="title" v-if="formPolicy!=1">历史记录</p>
            <Table border :columns="columnsA" :data="form.flowList"  v-if="formPolicy!=1" >
                <template slot-scope="{ row,index }" slot="action">
                    <span v-if="row.status=='RECALL'">撤回</span>
                    <span v-if="row.status=='PASS'">通过</span>
                    <span v-if="row.status=='REJECT'">驳回</span>
                </template>
                <template slot-scope="{ row,index }" slot="action2">
                    <span v-if="row.status=='RECALL'">
                        <div>{{row.deleteReason}}</div>
                        <div>{{row.comment}}</div>
                    </span>
                    <span v-else>{{row.comment}}</span>
                </template>
            </Table>
            <!-- 上传投保单 -->
            <UploadInsurance :form="form" :taskName="taskName" v-if="taskName&&taskId" />
        </div>
        <InvoiceInfo v-if="form.productCode=='JIANGONG_DEPOSIT'" :info="form.invoiceInfo"></InvoiceInfo>
    </div>
</template>
<script>
    import InsuranceInfo from './common/insuranceInfo'
    import SecurityPlan from './common/securityPlan'
    import UploadInsurance from '../common/customized/UploadInsurance'
    import InvoiceInfo from '../../customizedEmployerLiability/common/InvoiceInfo.vue'


    export default {
        components: { UploadInsurance,InsuranceInfo,SecurityPlan,InvoiceInfo },
        data () {
            return {
                taskName: this.$route.query.taskName || '',
                taskId: this.$route.query.taskId || '',
                form: {},
                columnsA: [
                    {
                        title: '节点',
                        key: 'taskName'
                    },
                    {
                        title: '审批人',
                        key: 'userName'
                    }, {
                        title: '审批状态',
                        slot: 'action'
                    },
                    {
                        title: '审批时间',
                        key: 'time'
                    }, {
                        title: '审批意见',
                        slot: 'action2'
                    },
                ],
                columns12: [
                    {
                        title: '附件类型',
                        key: 'fileTypeDesc'
                    },
                    {
                        title: '单号',
                        key: 'fileNo'
                    },
                    {
                        title: '附件名称',
                        key: 'fileName'
                    },
                    {
                        title: '上传人',
                        key: 'uploadUserName'
                    }, {
                        title: '上传时间',
                        key: 'createTime'
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 150,
                        align: 'center'
                    }
                ],
                data6: [],
                formPolicy: ''
            }
        },
        created () {
            this.formPolicy = this.$route.query.formPolicy ? this.$route.query.formPolicy : ''
            this.getDetail()
        },
        methods: {
            handelLoad () { },
            handleSee (url) {
                console.log(1111111111, url)
                window.open(url)
            },
            // 根据id获取信息
            // 获取投保单详情
            async getDetail () {
                if(this.formPolicy!=1){
                    let obj = {}
                    let url = ''
                    if (this.taskName || this.taskId) { // 通过工作台审批流进入
                    obj.applicationNo = this.$route.params.id
                    url = '/broker/insurance/application/detailByApplicationNo.admin'
                   } else {
                    obj.applicationId = this.$route.params.id
                    url = '/broker/insurance/application/detail.admin'
                   }
                   let res = await this.$axios.post(url, obj)
                   this.form = res
                   this.form.url = []
                   if (this.form.extraInfo.businessLicenseUrl) {
                    this.form.url = this.form.extraInfo.businessLicenseUrl.split(",")
                     }
                    this.form.url_ = []
                    if (this.form.extraInfo.projectContract) {
                    this.form.url_ = this.form.extraInfo.projectContract.split(",")
                    }
                    this.showDetail = true
                }else{                                                                                         
                    let res = await this.$axios.get('/broker/insurance/policy/detail.admin' , { insurancePolicyId: this.$route.query.insurancePolicyId })
                    this.form = res
                   this.form.url = []
                   if (this.form.extraInfo.businessLicenseUrl) {
                    this.form.url = this.form.extraInfo.businessLicenseUrl.split(",")
                     }
                    this.form.url_ = []
                    if (this.form.extraInfo.projectContract) {
                    this.form.url_ = this.form.extraInfo.projectContract.split(",")
                    }
                    this.showDetail = true
                }
             
                
            }
        }
    }
</script>

<style scoped>
    .title {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 15px;
    }

    .main {
        padding: 24px;
    }

    #taskForm {
        padding-bottom: 200px;
    }

    .demo-upload-list {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
    .upItem{
        overflow:hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
<style>
    #taskForm .ivu-form-item {
        margin-bottom: 0 !important;
    }
</style>
 


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customized/taskDetial.vue